import { graphql } from 'react-relay';

import { AlimTalkTemplateWindowPaginator_query$key } from '../../../relay/__generated__/AlimTalkTemplateWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const AlimTalkTemplateWindowPaginator_query = graphql`
  fragment AlimTalkTemplateWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: AlimTalkTemplateFilter }
    order: { type: AlimTalkTemplateOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int }
  )
  @refetchable(queryName: "AlimTalkTemplateWindowPaginatorRefreshQuery") {
    alimTalkTemplates(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...AlimTalkTemplateConnectionDataTable_alimTalkTemplateConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<AlimTalkTemplateWindowPaginator_query$key>, 'fragment'>;

const AlimTalkTemplateWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={AlimTalkTemplateWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (paginationProps) => (
          <Pagination {...paginationProps} pages={data.alimTalkTemplates.pages} loadPage={loadPage} />
        ),
      })
    }
  </FragmentWindowPaginator>
);

export default AlimTalkTemplateWindowPaginator;
